import React from 'react';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';
import CustomerRecord from './customer-record-item';
import { emptyObject } from 'ui-components/default-props/empty';

const DraggableCustomer = ({ draggableId, index, customerProps = emptyObject }) => {
  return (
    <Draggable draggableId={draggableId} index={index}>
      {(dragProvided) => (
        <div ref={dragProvided.innerRef} {...dragProvided.draggableProps} {...dragProvided.dragHandleProps}>
          <CustomerRecord {...customerProps} />
        </div>
      )}
    </Draggable>
  );
};

DraggableCustomer.propTypes = {
  draggableId: PropTypes.string.isRequired,
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  customerProps: PropTypes.shape({
    isSurvivor: PropTypes.bool,
  }),
};

export default DraggableCustomer;
